import { Clock, PlayCircle, CheckCircle2, AlertCircle } from "lucide-react";

const TimeSaver: React.FC = () => {
  return (
    <section className="bg-[#050505] text-white py-24 px-4 border-t border-white/5">
      <div className="max-w-6xl mx-auto">
        
        {/* Cabecera de la sección */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-6xl font-black mb-6 tracking-tighter">
            Stop trading <span className="text-cyan-400">hours</span> for <span className="text-cyan-400">code.</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            You could spend your entire weekend setting this up... or you could be live before your coffee gets cold.
          </p>
        </div>

        {/* Comparativa de Tiempo */}
        <div className="grid md:grid-cols-2 gap-8 mb-20">
          {/* El Camino Difícil */}
          <div className="bg-white/[0.02] border border-gray-400 p-8 rounded-3xl">
            <h3 className="flex items-center gap-2 text-xl font-bold mb-6 text-gray-400">
              <AlertCircle size={20} /> The Hard Way
            </h3>
            <ul className="space-y-4 sm:text-lg text-sm text-gray-500">
              <li className="flex gap-2">❌ Config Next.js & Prisma (45 min)</li>
              <li className="flex gap-2">❌ Design & Responsive UI (4+ hours)</li>
              <li className="flex gap-2">❌ Anti-spam & Troll filters (3+ hours)</li>
              <li className="flex gap-2">❌ Database & API Logic (2+ hours)</li>
              <li className="flex gap-2">❌ Testing & Debugging (2+ hours)</li>
              <li className="border-t border-white/10 pt-4 font-bold text-lg">Total: ~12 Hours of work</li>
            </ul>
          </div>

          {/* El Camino Cestio */}
          <div className="bg-cyan-400/5 border-2 border-cyan-400/30 p-8 rounded-3xl relative overflow-hidden">
            <div className="absolute top-0 right-0 bg-cyan-400 text-black font-black text-[10px] px-3 py-1 rounded-bl-lg uppercase tracking-widest">
              Recommended
            </div>
            <h3 className="flex items-center gap-2 text-xl font-bold mb-6 text-cyan-400">
              <CheckCircle2 size={20} /> With this Boilerplate
            </h3>
            <ul className="space-y-4 sm:text-lg text-sm text-gray-200">
              <li className="flex gap-2 text-cyan-400/80 font-medium">✅ Download & Install (2 min)</li>
              <li className="flex gap-2 text-cyan-400/80 font-medium">✅ Add your DB URL (1 min)</li>
              <li className="flex gap-2 text-cyan-400/80 font-medium">✅ Customize your Brand (5 min)</li>
              <li className="flex gap-2 text-cyan-400/80 font-medium">✅ Push to Vercel (2 min)</li>
              <li className="flex gap-2 text-cyan-400/80 font-medium">✅ Zero Trolls forever (Priceless)</li>
              <li className="border-t border-cyan-400/20 pt-4 font-black text-2xl text-white">Total: 10 Minutes</li>
            </ul>
          </div>
        </div>

        {/* Sección del Video de YouTube */}
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col items-center mb-8">
            <div className="flex items-center gap-2 mb-2">
                <PlayCircle className="text-red-500" size={24} />
                <span className="text-sm font-bold tracking-widest uppercase text-gray-400">Video Guide Included</span>
            </div>
            {/* <h3 className="text-2xl md:text-3xl font-bold text-center">
              Watch me set it up from scratch
            </h3> */}
          </div>

          {/* Video Embed Container */}
          <div className="relative aspect-video rounded-3xl overflow-hidden border border-white/10 shadow-[0_0_50px_rgba(34,211,238,0.1)] group">
            <iframe
              className="absolute inset-0 w-full h-full"
              src="https://www.youtube.com/embed/Qf-fZovQ8Fs" 
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>

          <p className="text-center mt-6 text-gray-400 text-sm">
            I’ll show you every step so you don’t get lost. 
            <span className="text-white"> No gatekeeping, just pure building.</span>
          </p>
        </div>

      </div>
    </section>
  );
};

export default TimeSaver;